module.exports = __webpack_public_path__ + "img/file-font-fill.fc5f71c5.svg";